//     import Header from "../Header";
// import BottomNav from "../BottomNav";
// import "./home.css";

// import {
//   FaSearch,
//   FaFilter,
//   FaHeart,
//   FaMapMarkerAlt
// } from "react-icons/fa";

// const Home = () => {
//   return (
//     <div className="app-container">

//       {/* HEADER */}
//       <Header />

//       {/* SEARCH */}
//       <div className="search-box">
//         <FaSearch className="icon" />
//         <input placeholder="Search by Property..." />
//         <FaFilter className="icon" />
//       </div>

//       {/* PREMIUM */}
//       <div className="section-header">
//         <h3>Premium Properties</h3>
//         <span className="see-all">See All ›</span>
//       </div>

//       <div className="horizontal-scroll">
//         <div className="premium-card">
//           <span className="badge">Premium</span>
//           <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab" />
//           <h4>Premium Downtown Commercial</h4>
//           <p className="price">₹2,50,00,000</p>
//         </div>

//         <div className="premium-card">
//           <span className="badge">Premium</span>
//           <img src="https://images.unsplash.com/photo-1564013799919-ab600027ffc6" />
//           <h4>Green Valley Residential</h4>
//           <p className="price">₹85,00,000</p>
//         </div>
//       </div>

//       {/* CATEGORIES */}
//       <h3 className="section-title">Categories</h3>
//       <div className="category-scroll">
//         <button className="cat active">All</button>
//         <button className="cat">Commercial</button>
//         <button className="cat">Residential</button>
//         <button className="cat">Industrial</button>
//       </div>

//       {/* AVAILABLE */}
//       <h3 className="section-title">Available Properties (6)</h3>

//       {/* PROPERTY CARD */}
//       <div className="property-card">
//         <span className="badge">Premium</span>
//         <FaHeart className="heart" />

//         <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab" />

//         <div className="card-body">
//           <h4>Premium Downtown Commercial Plot</h4>

//           <p className="location">
//             <FaMapMarkerAlt /> Downtown Business District
//           </p>

//           <div className="card-footer">
//             <span className="price">₹2,50,00,000</span>
//             <span className="area">5000 sq ft</span>
//           </div>

//           <span className="tag">Commercial</span>
//         </div>
//       </div>

//       {/* BOTTOM NAV */}
//       <BottomNav />

//     </div>
//   );
// };

// export default Home;



// import Footer from "../Footer";
// import Header from "../Header";
// import "./home.css";
// import {
//   FaSearch,
//   FaFilter,
//   FaHeart,
//   FaMapMarkerAlt
// } from "react-icons/fa";

// const Home = () => {
//   return (

//     <>

//     <Header />
//     <main className="container">

//       {/* SEARCH */}
//       <div className="search-box">
//         <FaSearch />
//         <input placeholder="Search by Property..." />
//         <FaFilter />
//       </div>

//       {/* PREMIUM */}
//       <div className="section-header">
//         <h2>Premium Properties</h2>
//         <a>See All</a>
//       </div>

//       <div className="premium-row">
//         <div className="premium-card">
//           <span className="badge">Premium</span>
//           <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab" />
//           <h4>Premium Downtown Commercial</h4>
//           <p>₹2,50,00,000</p>
//         </div>

//         <div className="premium-card">
//           <span className="badge">Premium</span>
//           <img src="https://images.unsplash.com/photo-1564013799919-ab600027ffc6" />
//           <h4>Green Valley Residential</h4>
//           <p>₹85,00,000</p>
//         </div>
//       </div>

//       {/* CATEGORIES */}
//       <h2>Categories</h2>
//       <div className="category-row">
//         <button className="active">All</button>
//         <button>Commercial</button>
//         <button>Residential</button>
//         <button>Industrial</button>
//       </div>

//       {/* AVAILABLE */}
//       <h2>Available Properties (6)</h2>

//       <div className="property-card">
//         <span className="badge">Premium</span>
//         <FaHeart className="fav" />

//         <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab" />

//         <div className="info">
//           <h3>Premium Downtown Commercial Plot</h3>
//           <p>
//             <FaMapMarkerAlt /> Downtown Business District
//           </p>

//           <div className="meta">
//             <span>₹2,50,00,000</span>
//             <span>5000 sq ft</span>
//           </div>

//           <span className="tag">Commercial</span>
//         </div>
//       </div>

//     </main>
// <Footer />
//     </>
//   );
// };

// export default Home;



import React, { useEffect, useRef, useState } from "react";
import { FaSearch, FaFilter } from "react-icons/fa";
import Header from "../Header";
import StateCarousel from "../../LandingPage/StateCarousel";
import Hero from "../../LandingPage/Hero";
import { useNavigate } from "react-router-dom";
import Footer from "../../LandingPage/Footer";
import axios from "axios";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import './home.css';

const API_BASE = "https://api.propertygalleria.in/master/api";

const Home = () => {

  const [imageIndexes, setImageIndexes] = useState({});

  const [properties, setProjects] = useState([]);
  const [categories, setCategories] = useState([]);
  const [highways, setHighways] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [price, setPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(0);
  const [selectedHighway, setSelectedHighway] = useState("All");

  /* ========== FETCH PROJECTS ========== */
  // const fetchProjects = async () => {
  //   try {
  //     const res = await axios.get(`${API_BASE}/get/projects`);
  //     const filter = res.data.filter((P) => P.status === "Approved");
  //     setProjects(filter);
  //   } catch (err) {
  //     console.error(err);
  //     alert("Failed to load projects");
  //   }
  // };


  const fetchProjects = async () => {
    try {
      const [propRes, catRes] = await Promise.all([
        axios.get(`${API_BASE}/get/projects`),
        axios.get("https://api.propertygalleria.in/api/property-categories")
      ]);

      const filter = propRes.data.filter((P) => P.status === "Approved");

      setProjects(filter);
      setCategories(catRes.data);
      console.log('this is filter', filter)

      const highest = Math.max(...filter.map(p => Number(p.price) || 0));

      setMaxPrice(highest);
      setPrice(highest);
      // Suppose 'filter' is your array of properties
      const uniqueHighways = [
        ...new Set(filter.map((p) => p.zone_desc).filter(Boolean))
      ];

      setHighways(uniqueHighways);
      // Set to state
      setHighways(uniqueHighways);
    } catch (err) {
      console.error(err);
      alert("Failed to load projects");
    }
  };


  useEffect(() => {
    fetchProjects();
  }, []);
  const filteredProperties = properties.filter((p) => {

    const matchSearch =
      p.title?.toLowerCase().includes(search.toLowerCase()) ||
      p.location?.toLowerCase().includes(search.toLowerCase());

    const matchCategory =
      selectedCategory === "All" ||
      p.category?.toLowerCase() === selectedCategory.toLowerCase();

    const matchPrice = Number(p.price) <= price;

    // return matchSearch && matchCategory && matchPrice;
    const matchHighway =
      selectedHighway === "All" ||
      p.zone_desc?.toLowerCase() === selectedHighway.toLowerCase();

    return matchSearch && matchCategory && matchPrice && matchHighway;
  });

  const [filterOpen, setFilterOpen] = useState(false);
  const navigate = useNavigate();

  const heroImages = [
    "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab",
    "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
    "https://images.unsplash.com/photo-1501183638710-841dd1904471",
  ];


  const scrollRef = useRef(null);

  const scroll = (direction) => {
    scrollRef.current.scrollBy({
      left: direction === "left" ? -350 : 350,
      behavior: "smooth"
    });
  };

  const getWishlist = () => {
    return JSON.parse(localStorage.getItem("wishlist")) || [];
  };

  const saveWishlist = (data) => {
    localStorage.setItem("wishlist", JSON.stringify(data));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setImageIndexes(prev => {
        const updated = { ...prev };

        properties.forEach(p => {
          const imgs = p.property_images || [];
          if (imgs.length > 0) {
            const current = updated[p.id] || 0;
            updated[p.id] = (current + 1) % imgs.length;
          }
        });

        return updated;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [properties]);

  const changeImage = (e, id, images, dir) => {
    e.stopPropagation();

    setImageIndexes(prev => {
      const current = prev[id] || 0;
      const next =
        dir === "left"
          ? (current - 1 + images.length) % images.length
          : (current + 1) % images.length;

      return { ...prev, [id]: next };
    });
  };
  const formatPrice = (num) => {
    if (num >= 10000000) {
      // Crores
      return `${(num / 10000000).toFixed(2)} Cr`;
    } else if (num >= 100000) {
      // Lakhs
      return `${(num / 100000).toFixed(2)} L`;
    } else if (num >= 1000) {
      return `${(num / 1000).toFixed(0)}K`;
    } else {
      return num;
    }
  };
  console.log('this is filteredProperties', filteredProperties)
  return (
    <>
      <Header />
      {/* HERO SECTION */}
      <Hero />
      <div className="search-box " >
        <FaSearch />
        {/* <input placeholder="Search by Property..." /> */}
        <input
          placeholder="Search by Property..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <FaFilter onClick={() => setFilterOpen(true)} />
      </div>
      {/* SEARCH BAR */}

      {/* <StateCarousel /> */}
      {/* FILTER DRAWER */}
      {/* <div className={`filter-drawer ${filterOpen ? "open" : ""}`}>
        <h3>Filters</h3>

        <label>Category</label>
        <select>
          <option>All</option>
          <option>Premium</option>
          <option>Luxury</option>
        </select>

        <label>Property Type</label>
        <select>
          <option>Apartment</option>
          <option>Villa</option>
          <option>Land</option>
        </select>

        <label>Price Range</label>
        <input type="range" />

        <button onClick={() => setFilterOpen(false)}>Apply Filters</button>
      </div> */}

      {/* {filterOpen && (
        <div className="filter-overlay" onClick={() => setFilterOpen(false)} />
      )} */}

      {filterOpen && (
        <>
          <div className="filter-overlay" onClick={() => setFilterOpen(false)} />

          <div className="filter-modal">

            <h3>Filters</h3>

            <label>Category</label>

            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              <option value="All">All</option>

              {categories.map((cat) => (
                <option key={cat.id}>
                  {cat.category_name}
                </option>
              ))}
            </select>
            <label>Highway</label>

            <select
              value={selectedHighway}
              onChange={(e) => setSelectedHighway(e.target.value)}
            >
              <option value="All">All</option>

              {highways.map((hw, index) => (
                <option key={index} value={hw}>
                  {hw}
                </option>
              ))}
            </select>

            <label>Max Price</label>

            <input
              type="range"
              min="0"
              max={maxPrice}
              value={price}
              onChange={(e) => setPrice(Number(e.target.value))}
            />

            <p>₹ {formatPrice(price)}</p>

            <button onClick={() => setFilterOpen(false)}>
              Apply Filters
            </button>

          </div>
        </>
      )}


      <div style={{ padding: "30px" }}>
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
          <h2 style={{ fontSize: 28 }}>Available Properties</h2>

          <div>
            <button onClick={() => scroll("left")} style={arrowBtn}>◀</button>
            <button onClick={() => scroll("right")} style={arrowBtn}>▶</button>
          </div>
        </div>

        {/* Slider */}
        <div
          ref={scrollRef}
          style={{
            display: "flex",
            gap: 20,
            overflowX: "auto",
            scrollBehavior: "smooth",
            paddingBottom: 10
          }}
        >



          {filteredProperties.map((p) => {
            const wishlist = getWishlist();
            const isWishlisted = wishlist.some(item => item.id === p.id);

            return (
              <div key={p.id} style={card}>

                {/* Image */}
                <div style={{ position: "relative" }}>
                  {/* <img
                    src={p.property_images}
                    alt=""
                    style={image}
                    onClick={() => navigate(`/property`)}
                  /> */}

                  <div style={{ position: "relative" }}>
                    <img
                      src={p.property_images?.[imageIndexes[p.id] || 0]}
                      alt=""
                      style={image}
                      onClick={() =>
                        navigate(`/properties/${p.id}`, { state: { property: p } })
                      }
                    />

                    {/* Left button */}
                    <button
                      onClick={(e) =>
                        changeImage(e, p.id, p.property_images, "left")
                      }
                      style={sliderBtnLeft}
                    >
                      ◀
                    </button>

                    {/* Right button */}
                    <button
                      onClick={(e) =>
                        changeImage(e, p.id, p.property_images, "right")
                      }
                      style={sliderBtnRight}
                    >
                      ▶
                    </button>
                  </div>


                  {p.premium && <div style={premiumTag}>Premium</div>}

                  {/* ❤️ HEART ICON */}
                  <div
                    style={{
                      ...heartIcon,
                      color: isWishlisted ? "red" : "#000"
                    }}
                    onClick={(e) => {
                      e.stopPropagation(); // IMPORTANT (avoid image click)

                      let updatedWishlist = getWishlist();

                      if (isWishlisted) {
                        // remove
                        updatedWishlist = updatedWishlist.filter(
                          item => item.id !== p.id
                        );
                      } else {
                        // add
                        updatedWishlist.push(p);
                      }

                      saveWishlist(updatedWishlist);
                      // window.location.reload(); // refresh UI
                    }}
                  >
                    {/* {isWishlisted ? "❤️" : "🤍"} */}
                    {isWishlisted ? (
                      <FavoriteIcon sx={{ color: "red" }} />
                    ) : (
                      <FavoriteBorderIcon />
                    )}
                  </div>
                </div>

                {/* Content */}
                <div style={{ padding: 15 }}>
                  <h3 style={{ margin: "10px 0" }}>{p.title}</h3>
                  <p style={{ color: "#666", marginBottom: 10 }}>
                    📍 {p.location}
                  </p>

                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span style={{ color: "#2563eb", fontWeight: "bold" }}>
                      {p.price}
                    </span>
                    <span style={{ color: "#555" }}>{p.area} Sq ft</span>
                  </div>

                  <div style={typeBadge}>{p.category}</div>
                </div>
              </div>
            );
          })}


          {/* View All Card */}
          <div style={viewAllCard}>
            <h3>View All Properties</h3>
            <button style={viewAllBtn} onClick={() => navigate("/properties")}>Explore</button>
          </div>
        </div>
      </div>


      {/* STYLES */}
      <style>{`
        :root {
          --purple: #7f4070;
          --green: #4a8c7c;
        }

        body {
          margin: 0;
          font-family: Arial, sans-serif;
          background: #f6f7f9;
        }

        /* HERO */
        // .hero {
        //   height: 280px;
        //   overflow: hidden;
        //   position: relative;
        // }

        .hero-track {
          display: flex;
          width: 200%;
          animation: slide 18s linear infinite;
        }

        .hero-slide {
          min-width: 100%;
          background-size: cover;
          background-position: center;
        }

        @keyframes slide {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }

        .hero-overlay {
          position: absolute;
          inset: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-left: 20px;
          color: #fff;
          background: linear-gradient(to right, rgba(0,0,0,.6), transparent);
        }

        .hero-overlay h1 {
          font-size: 32px;
          animation: fadeDown .8s ease;
        }

        @keyframes fadeDown {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* SEARCH */
        .search-box {
          display: flex;
          align-items: center;
          margin: 20px;
          padding: 14px;
          border-radius: 14px;
          background: #fff;
          gap: 10px;
          box-shadow: 0 8px 20px rgba(0,0,0,.08);
        }

        .search-box input {
          flex: 1;
          border: none;
          outline: none;
          font-size: 15px;
        }

        /* FILTER */
        .filter-drawer {
          position: fixed;
          bottom: -100%;
          left: 0;
          width: 100%;
          background: #fff;
          border-radius: 20px 20px 0 0;
          padding: 20px;
          transition: .4s;
          z-index: 1000;
        }

        .filter-drawer.open {
          bottom: 0;
        }

        .filter-drawer h3 {
          margin-bottom: 10px;
          color: var(--purple);
        }

        .filter-drawer label {
          display: block;
          margin-top: 10px;
        }

        .filter-drawer select,
        .filter-drawer input {
          width: 100%;
          padding: 10px;
          margin-top: 6px;
        }

        .filter-drawer button {
          margin-top: 20px;
          width: 100%;
          padding: 12px;
          border: none;
          background: linear-gradient(135deg, var(--purple), var(--green));
          color: #fff;
          border-radius: 12px;
        }

        .filter-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,.4);
          z-index: 999;
        }

        /* PROPERTY */
        .property-section {
          padding: 20px;
        }

        .section-header {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
        }

        .property-scroll {
          display: flex;
          gap: 16px;
          overflow-x: auto;
          padding-bottom: 10px;
        }

        .property-card {
          min-width: 260px;
          background: #fff;
          border-radius: 20px;
          box-shadow: 0 10px 25px rgba(0,0,0,.1);
          overflow: hidden;
          position: relative;
        }

        .property-card img {
          width: 100%;
          height: 180px;
          object-fit: cover;
        }

        .property-card h3 {
          padding: 10px;
          font-size: 16px;
        }

        .price {
          padding: 0 10px 15px;
          color: #0d6efd;
          font-weight: bold;
        }

        .badge {
          position: absolute;
          top: 10px;
          left: 10px;
          background: gold;
          padding: 6px 14px;
          border-radius: 20px;
          font-size: 12px;
        }
      `}</style>

      <Footer />
    </>
  );
};


/* ------------------ STYLES ------------------ */
const sliderBtnLeft = {
  position: "absolute",
  top: "50%",
  left: 5,
  transform: "translateY(-50%)",
  background: "rgba(0,0,0,0.5)",
  color: "#fff",
  border: "none",
  cursor: "pointer",
  padding: "5px 8px",
  borderRadius: 5
};

const sliderBtnRight = {
  ...sliderBtnLeft,
  left: "auto",
  right: 5
};

const card = {
  minWidth: 300,
  background: "#fff",
  borderRadius: 16,
  boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
  overflow: "hidden"
};

const image = {
  width: "100%",
  height: 180,
  objectFit: "contain"
};

const premiumTag = {
  position: "absolute",
  top: 12,
  left: 12,
  background: "#fbbf24",
  color: "#fff",
  padding: "6px 12px",
  borderRadius: 20,
  fontSize: 12,
  fontWeight: "bold"
};

const heartIcon = {
  position: "absolute",
  top: 12,
  right: 12,
  background: "#fff",
  borderRadius: "10%",
  width: 46,
  height: 26,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 10,
  cursor: "pointer"
};

const typeBadge = {
  marginTop: 12,
  background: "#e0ecff",
  color: "#2563eb",
  padding: "6px 12px",
  borderRadius: 20,
  display: "inline-block",
  fontSize: 12
};

const arrowBtn = {
  background: "#2563eb",
  color: "#fff",
  border: "none",
  padding: "10px 14px",
  borderRadius: "50%",
  marginLeft: 8,
  cursor: "pointer"
};

const viewAllCard = {
  minWidth: 260,
  border: "2px dashed #2563eb",
  borderRadius: 16,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center"
};

const viewAllBtn = {
  marginTop: 10,
  background: "#2563eb",
  color: "#fff",
  border: "none",
  padding: "10px 20px",
  borderRadius: 8,
  cursor: "pointer"
};



export default Home;
